module.exports = __webpack_public_path__ + "img/1_2-parco-2-botanico.3c856d67.png";